import { MapPin, CalendarClock, Gift, ArrowLeft, CheckCircle2 } from "lucide-react";

export const Confirmation = ({ data, floatImg, onDone }) => {
  return (
    <div className="relative z-[2] flex min-h-screen items-center justify-center overflow-hidden bg-retro-blue px-6 py-16" data-testid="confirmation-screen">
      <img
        src={floatImg}
        alt=""
        className="pointer-events-none absolute -right-10 -top-10 w-48 animate-float-bob opacity-90 sm:w-64"
        aria-hidden="true"
      />
      <div className="relative w-full max-w-lg border-2 border-retro-ink bg-white p-8 shadow-retro-xl sm:p-10">
        <div className="mb-5 inline-flex rotate-2 items-center gap-2 border-2 border-retro-ink bg-retro-yellow px-4 py-2 shadow-retro-sm">
          <CheckCircle2 className="h-5 w-5 text-retro-ink" />
          <span className="font-chango text-sm text-retro-ink">You're in!</span>
        </div>

        <h1 className="font-chango text-4xl leading-tight text-retro-ink sm:text-5xl" data-testid="confirmation-title">
          See you at the slide!
        </h1>
        <p className="mt-3 text-lg font-medium text-retro-ink/80">
          Thanks {data?.rsvp?.name}. Here's everything you need:
        </p>

        <div className="mt-7 space-y-4">
          <div className="flex items-start gap-3 border-2 border-retro-ink bg-retro-cream p-4">
            <CalendarClock className="mt-0.5 h-6 w-6 shrink-0 text-retro-orange" />
            <div>
              <p className="font-chango text-retro-ink">When</p>
              <p className="font-medium text-retro-ink/80" data-testid="confirmation-datetime">{data?.datetime}</p>
            </div>
          </div>

          <div className="flex items-start gap-3 border-2 border-retro-ink bg-retro-cream p-4">
            <MapPin className="mt-0.5 h-6 w-6 shrink-0 text-retro-blue" />
            <div>
              <p className="font-chango text-retro-ink">Where</p>
              <p className="font-semibold text-retro-ink" data-testid="confirmation-address">{data?.address}</p>
            </div>
          </div>

          <div className="flex items-start gap-3 border-2 border-retro-ink bg-retro-cream p-4">
            <Gift className="mt-0.5 h-6 w-6 shrink-0 text-retro-pink" />
            <div>
              <p className="font-chango text-retro-ink">You're bringing</p>
              {data?.items_claimed?.length ? (
                <ul className="mt-1 space-y-1" data-testid="confirmation-items">
                  {data.items_claimed.map((name) => (
                    <li key={name} className="flex items-center gap-2 font-medium text-retro-ink/80">
                      <span className="inline-block h-2.5 w-2.5 shrink-0 rotate-45 border-2 border-retro-ink bg-retro-pink" aria-hidden="true" />
                      {name}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="font-medium text-retro-ink/80" data-testid="confirmation-items">Just yourself — perfect!</p>
              )}
            </div>
          </div>
        </div>

        <button
          onClick={onDone}
          data-testid="confirmation-back-button"
          className="mt-8 inline-flex items-center gap-2 rounded-full border-2 border-retro-ink bg-white px-6 py-3 font-chango text-retro-ink shadow-retro transition-[transform,box-shadow] duration-150 hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-retro-sm"
        >
          <ArrowLeft className="h-5 w-5" />
          Back to the party
        </button>
      </div>
    </div>
  );
};
